import { lazy } from 'react';
export const LazyPlanSelection = lazy(() => import('@/pages/onboarding/PlanSelection'));
